import { EmployeeAccessTypes, LoyaltyProgramsTypesEnum, MerchantStatusType } from '@shared/enums';
import { TimeZonesEnum } from '@ep/shared';

interface ApplicationProfileEmployee {
  $id: number;
  EmployeeId: number;
  NameFirst: string;
  NameLast: string;
  AccessType: EmployeeAccessTypes;
}

interface ApplicationProfileLoyaltyProgram {
  LoyaltyProgramId: number;
  Name: string;
  LoyaltyProgramType: LoyaltyProgramsTypesEnum;
  ReceiveAmount: number;
}

interface ApplicationProfileMerchant {
  MerchantId: number;
  Name: string;
  StatusType: MerchantStatusType;
  LoyaltyProgram: ApplicationProfileLoyaltyProgram;
}

interface ApplicationProfileLocation {
  LocationId: number;
  Name: string;
  Address: string;
  UtcOffsetHour: number;
  PhoneNumber: number;
  TimeZoneType: TimeZonesEnum;
}
export interface PortalTheme {
  primary: string;
  backgroundColor: string;
  defaultTextColor: string;
  sidebar: {
    backgroundColor: {
      primary: string;
      secondary: string;
      active: string;
      dropdown: string;
    };
    textColor: string;
    logoBackgroundColor: string;
  };
  header: {
    primary: string;
    backgroundColor: string;
    itemsColor: string;
    textColor: string;
  };
  dashboard: {
    coloredCardTextColor: string;
    cardBackgroundColor: string;
    headerBackgroundColor: string;
    headerTextColor: string;
    sales: string;
    loyalty: string;
    rewards: string;
    reviews: string;
  };
  table: {
    header: {
      backgroundColor: string;
      textColor: string;
    };
    subHeaderBackgroundColor: string;
    subHeaderTextColor: string;
    statusColors: {
      primary: string;
      secondary: string;
      warning: string;
      danger: string;
    };
    body: {
      primaryBackgroundColor: string;
      secondaryBackgroundColor: string;
      textColor: string;
    };
  };
  form: {
    header: {
      primaryBackgroundColor: string;
      secondaryBackgroundColor: string;
      textColor: string;
      itemsColor: string;
      itemsTextColor: string;
    };
    backgroundColor: string;
  };
}
export interface ApplicationProfilePortalTheme {
  Theme: PortalTheme;
  PrimaryLogo: string;
  SecondaryLogo: string;
  FavIcon?: string;
  CoalitionName?: string;
}
export interface ApplicationProfile {
  Employee: ApplicationProfileEmployee;
  Merchant: ApplicationProfileMerchant;
  Location: ApplicationProfileLocation;
  PortalTheme: ApplicationProfilePortalTheme;
}
